import React, { useEffect, useState } from 'react';
import Layout from 'components/layout';
import { orderBy } from 'lodash';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Grid, Typography } from '@material-ui/core';
import TextBlock from 'components/pages/DemoRequest/TextBlock';
import FormBlock from 'components/pages/DemoRequest/FormBlock';
import LinkBlocks from 'components/LinkBlock/LinkBlocks';
import LinkBlockBackground from 'components/pages/Solution/Marketing/LinkBlockBackground';
import { breakpoint } from 'utils/mediaQueries';

const LinkGrid = styled(Grid)`
  margin-top: 0rem;
  position: relative;
  padding-top: 5rem;
  padding-bottom: 4rem;
  background-position: top;
  ${breakpoint.down('lg')`
  padding-top: 6rem;padding-bottom: 2rem;margin-top: 0;`}
  ${breakpoint.down('md')`
  padding-bottom: 4rem;`}
  ${breakpoint.down('sm')`padding-top:0;padding-bottom: 6rem;`};
`;

const Container = styled.div`
  min-height: ${({ headerHeight }) =>
    `calc(80vh - ${headerHeight}px - 1.125em)`};
  width: 100%;
  display: inline-flex;
  ${breakpoint.down('md')`
  display: block;`};
`;

const LogosContainer = styled.div`
  width: calc(100% - 6em);
  ${breakpoint.down('sm')`
  text-align: center;
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  `};
  margin-left: 6em;
`;

const LogoTitle = styled(Typography)`
  font-weight: bold;
  font-size: 2em;
`;

const ImagesBlock = styled.div`
  display: flex;
  justify-content: space-around;
  ${breakpoint.down('sm')`
  flex-direction: column;
  width: 50%;
  align-items: center;
  `};
  width: 100%;
  margin-top: 2em;

  & img {
    object-fit: contain;
  }
`;

const DemoRequestPage = props => {
  const [heightHeader, setHeightHeader] = useState(0);
  useEffect(() => {
    const headerNav = document.getElementById('headerNav');
    if (headerNav) {
      setHeightHeader(headerNav && headerNav.offsetHeight);
    }
  }, [heightHeader]);

  const {
    dataBlockLinkBody,
    textBlockData,
    formBlockData,
    dataMessage,
    imagesLogosBlock,
  } = props.data;

  const images = imagesLogosBlock.nodes.map((img, ind) => {
    if (img.base === 'heineken_experience_green.png') {
      return { ...img, index: 4 };
    } else if (img.base === 'maif.png') {
      return { ...img, index: 2 };
    } else if (
      img.base === 'loreal.png' &&
      props.pageContext.langKey === 'en'
    ) {
      return { ...img, index: 3 };
    } else if (img.base === 'tui.png') {
      return { ...img, index: 1 };
    } else {
      return { ...img, index: ind };
    }
  });

  const linkBlocksData = {
    markdownContent: dataBlockLinkBody,
  };

  const testimonialBlockData = {
    markdownContent: props.data.dataTestimonialBlock.nodes,
    imagesSliderQuotes:
      props.data.imagesQuotesTestimonialBlock &&
      props.data.imagesQuotesTestimonialBlock.nodes,
  };

  return (
    <Layout location={props.location} seo={{ ...props.seo }}>
      <Container headerHeight={heightHeader}>
        <TextBlock
          data={textBlockData}
          testimonialBlockData={testimonialBlockData}
          langKey={props.pageContext.langKey}
        />
        <FormBlock
          title={formBlockData.html}
          langKey={props.pageContext.langKey}
          confirmMessage={dataMessage.rawMarkdownBody}
          {...props}
        />
      </Container>
      <LogosContainer>
        <LogoTitle>
          <FormattedMessage id="demoRequest.logoBlockTitle" />
        </LogoTitle>
        <ImagesBlock>
          {orderBy(images, img => img.index)?.map(image => (
            <img src={image.childImageSharp.fluid.src} alt={image.base} loading="lazy" />
          ))}
        </ImagesBlock>
      </LogosContainer>
      <LinkGrid>
        <LinkBlocks
          data={linkBlocksData.markdownContent.nodes}
          lang={props.pageContext.langKey}
          disablePadding
        />
        <LinkBlockBackground />
      </LinkGrid>
    </Layout>
  );
};

export default DemoRequestPage;
